import React, { useEffect, useState, useContext } from "react";
import useForm from "../../../../services/UseForm";
import validate from '../../../../validations/admin/product/CoffeeValidate';
import '../../../../css/popUpForm.css';
import axios from "axios";
import { API } from "../../../../services/api";
import { CoffeeContext } from "../Coffee";

axios.defaults.baseURL = API;

function UpdateCoffee(props) {

    const {CoffeeList, setCoffeeList, setShowData, CountryList, FarmList, TypeList, GradeList, BeanStatusList, ProccessList, RoasterTypeList, data} = useContext(CoffeeContext);
    const [VarityList, setVarityList] = useState([]);

    const handleInputChange = event => {
        const { name, value } = event.target;
        handleChange(name, value)
    };

    const handelInputNumber = (e) => {
        const { name, value } = e.target;
          const re = /^[0-9\b]+$/;
          if (value) {
              if (value === '' || re.test(value.split(',').join(''))) {
                  handleChange(name, value.split(',').join(''));
              }  
          } else {
              handleChange(name, 0);
          }
      }

      const handleSelectCountry= (e) => {
        const { value } = e.target;
        if (value) {
            handleChange("Country", value);
            handleChange("CountryID", e.target.children[e.target.selectedIndex].getAttribute('data-id'));
        } else {
            handleChange("Country", "");
            handleChange("CountryID", "");
        }
    };

    const handleSelectFarm = (e) => {
        const { value } = e.target;
        if (value) {
            handleChange("Farm", value);
            handleChange("FarmID", e.target.children[e.target.selectedIndex].getAttribute('data-id'));
        } else {
            handleChange("FarmID", "");
            handleChange("Farm", "");
        }
    };

    
      const handleSelectType = (e) => {
        const { value } = e.target;
        if(value){
            getVarityByTypeID(e.target.children[e.target.selectedIndex].getAttribute('data-id'));
            handleChange("Type", value);
            handleChange("TypeID", e.target.children[e.target.selectedIndex].getAttribute('data-id'));
        } else {
            handleChange("Type", "");
            handleChange("TypeID", "");
            handleChange("Varity", "");
            handleChange("VarityID", "");
        }
        
    };

    async function getVarityByTypeID(value) {
        let token = localStorage.getItem("token");
        await axios.get(`/getAllVarityByTypeID/${value}`, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
          let temOrder = response?.data;
          console.log(temOrder)
          if(temOrder.length > 0){
            setVarityList(temOrder);
          } else {
            setVarityList([]);
          }
        }).catch((err) => {
            setVarityList([]);
            console.log(err);
        });
    }

    const handleSelectVarity = (e) => {
        const { value } = e.target;
        if (value) {
            handleChange("Varity", value);
            handleChange("VarityID", e.target.children[e.target.selectedIndex].getAttribute('data-id'));
        } else {
            handleChange("Varity", "");
            handleChange("VarityID", "");
        }
    };

    const handleSelectGrade = (e) => {
        const { value } = e.target;
        if (value) {
            handleChange("Grade", value);
            handleChange("GradeID", e.target.children[e.target.selectedIndex].getAttribute('data-id'));
        } else {
            handleChange("GradeID", "");
            handleChange("Grade", "");
        }
    };

    const handleSelectBeanStatus = (e) => {
        const { value } = e.target;
        if (value) {
            handleChange("BeanStatus", value);
            handleChange("BeanStatusID", e.target.children[e.target.selectedIndex].getAttribute('data-id'));
        } else {
            handleChange("BeanStatusID", "");
            handleChange("BeanStatusID", "");
        }
    };

    const handleSelectProccess = (e) => {
        const { value } = e.target;
        if (value) {
            handleChange("Proccess", value);
            handleChange("ProccessID", e.target.children[e.target.selectedIndex].getAttribute('data-id'));
        } else {
            handleChange("Proccess", "");
            handleChange("ProccessID", "");
        }
    };

     const handleSelectRoaster = (e) => {
        const { value } = e.target;
        if (value) {
            handleChange("Roaster", value);
            handleChange("RoasterID", e.target.children[e.target.selectedIndex].getAttribute('data-id'));
        } else {
            handleChange("Roaster", "");
            handleChange("RoasterID", "");
        }
    };
    async function update() {
        let token = localStorage.getItem("token");
        var data = {
            CoffeeID: values.CoffeeID,
            Barcode: values.Barcode,
            ProductName: values.ProductName,
            Buy_Price: values.Buy_Price,
            Sell_Price: values.Sell_Price,
            CountryID: values.CountryID,
            FarmID: values.FarmID,
            VarityID: values.VarityID,
            TypeID: values.TypeID,
            GradeID: values.GradeID,
            BeanStatusID: values.BeanStatusID,
            ProccessID: values.ProccessID,
            RoasterID: values.RoasterID,
            TestNote: values.TestNote,
            StatusID: 1,
        }
        await axios.put(`/UpdateCoffee/${values.CoffeeID}`, data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
            getAllCoffee();
            ClearData();
            props.onClick(false);
        }).catch((err) => {
            console.log(err);
        });
    };

    async function getAllCoffee() {
        axios.get("/getAllCoffee").then((response) => {
          let Data = response?.data;
          setCoffeeList(Data);
          setShowData(Data);
        }).catch((error) => {
          console.log(error);
        });
    }

    const ClearData = () => {
        handleChange("Barcode", "");
        handleChange("ProductName", "");
        handleChange("EngName", "");
        handleChange("Buy_Price", "");
        handleChange("Sell_Price", "");
        handleChange("TestNote", "");
    }

    const {
        values,
        errors,
        handleChange,
        handleSubmit,
    } = useForm(update, validate);

    useEffect(() => {
        data.forEach(value => {
            handleChange("CoffeeID", value.CoffeeID);
            handleChange("Barcode", value.Barcode);
            handleChange("ProductName", value.ProductName);
            handleChange("Buy_Price", value.Buy_Price);
            handleChange("Sell_Price", value.Sell_Price);
            handleChange("CountryID", value.CountryID);
            handleChange("Country", value.Country);
            handleChange("FarmID", value.FarmID);
            handleChange("Farm", value.Farm);
            handleChange("VarityID", value.VarityID);
            handleChange("Varity", value.Varity);
            handleChange("TypeID", value.TypeID);
            handleChange("Type", value.Type);
            handleChange("GradeID", value.GradeID);
            handleChange("Grade", value.Grade);
            handleChange("BeanStatusID", value.BeanStatusID);
            handleChange("BeanStatus", value.BeanStatus);
            handleChange("ProccessID", value.ProccessID);
            handleChange("Proccess", value.Proccess);
            handleChange("RoasterID", value.RoasterID);
            handleChange("Roaster", value.Roaster);
            handleChange("TestNote", value.TestNote);
            handleChange("CheckBarcode", "");
        });

    }, [data]);

    return (
        <div style={{ display: props && props.show ? 'flex' : 'none' }} className="popUpForm">
            <div className="popUpcontent">
                <div className="popUpHeader">
                    <span>ແກ້ໄຂຂໍ້ມູນເມັດກາເຟ</span>
                </div>
                <div className="popUpBody">
                    <form onSubmit={handleSubmit} noValidate>
                        <div className="form-row">
                            <div className="form-group">
                                <span>Barcode</span>
                                <input className={`input form-control ${errors.Barcode && 'is-invalid'}`} type="text" name="Barcode" onChange={(e) => handleInputChange(e)} value={values.Barcode || ''} required />
                                {errors.Barcode && (
                                    <p className="invalid-feedback">{errors.Barcode}</p>
                                )}
                            </div>
                            <div className="form-group">
                                <span>ຊື່ກາເຟ</span>
                                <input className={`input form-control ${errors.ProductName && 'is-invalid'}`} type="text" name="ProductName" onChange={(e) => handleInputChange(e)} value={values.ProductName || ''} required />
                                {errors.ProductName && (
                                    <p className="invalid-feedback">{errors.ProductName}</p>
                                )}
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-group">
                                <span>ລາຄາຊື້</span>
                                <input className={`input form-control ${errors.Buy_Price && 'is-invalid'}`} type="text" name="Buy_Price" onChange={(e) => handelInputNumber(e)} value={values.Buy_Price || ''} required />
                                {errors.Buy_Price && (
                                    <p className="invalid-feedback">{errors.Buy_Price}</p>
                                )}
                            </div>
                            <div className="form-group">
                                <span>ລາຄາຂາຍ</span>
                                <input className={`input form-control ${errors.Sell_Price && 'is-invalid'}`} type="text" name="Sell_Price" onChange={(e) => handelInputNumber(e)} value={values.Sell_Price || ''} required />
                                {errors.Sell_Price && (
                                    <p className="invalid-feedback">{errors.Sell_Price}</p>
                                )}
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-group">
                                <label>ປະເທດ: </label>
                                <select name="CountryID" onChange={(e) => handleSelectCountry(e)}
                                    className={`input form-control ${errors.CountryID && 'is-invalid'}`}>
                                     { CountryList && CountryList.map((x, y) => {
                                        if (x.Country == values.Country) {
                                            return (
                                                <option 
                                                key={x.CountryID}
                                                data-id={x.CountryID}
                                                value={x.CountryID} selected>
                                                    {x.Country}
                                                </option>
                                            )
                                        } else {
                                            return (
                                                <option key={x.CountryID}
                                                data-id={x.CountryID}
                                                value={x.CountryID}>
                                                    {x.Country}
                                                </option>
                                            )
                                        }
                                    })}
                                </select>
                            </div>
                            <div className="form-group">
                                <label>ສວນ: </label>
                                <select name="FarmID" onChange={(e) => handleSelectFarm(e)}
                                    className={`input form-control ${errors.FarmID && 'is-invalid'}`}>
                                    { FarmList && FarmList.map((x, y) => {
                                        if (x.Farm == values.Farm) {
                                            return (
                                                <option 
                                                key={x.FarmID}
                                                data-id={x.FarmID}
                                                value={x.FarmID} selected>
                                                    {x.Farm}
                                                </option>
                                            )
                                        } else {
                                            return (
                                                <option key={x.FarmID}
                                                data-id={x.FarmID}
                                                value={x.FarmID}>
                                                    {x.Farm}
                                                </option>
                                            )
                                        }
                                    })}
                                </select>
                            </div>
                            <div className="form-group">
                                <label>ປະເພດ: </label>
                                <select name="TypeID" onChange={(e) => handleSelectType(e)}
                                    className={`input form-control ${errors.TypeID && 'is-invalid'}`}>

                                    { TypeList && TypeList.map((x, y) => {
                                        if (x.Type == values.Type) {
                                            return (
                                                <option 
                                                key={x.TypeID}
                                                data-id={x.TypeID}
                                                value={x.TypeID} selected>
                                                    {x.Type}
                                                </option>
                                            )
                                        } else {
                                            return (
                                                <option key={x.TypeID}
                                                data-id={x.TypeID}
                                                value={x.TypeID}>
                                                    {x.Type}
                                                </option>
                                            )
                                        }
                                    })}
                                </select>
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-group">
                                <label>ສາຍພັນ: </label>
                                <select name="VarityID" onChange={(e) => handleSelectVarity(e)}
                                    className={`input form-control ${errors.VarityID && 'is-invalid'}`}>
                                    { VarityList && VarityList.map((x, y) => {
                                        if (x.Varity == values.Varity) {
                                            return (
                                                <option 
                                                key={x.VarityID}
                                                data-id={x.VarityID}
                                                value={x.VarityID} selected>
                                                    {x.Varity}
                                                </option>
                                            )
                                        } else {
                                            return (
                                                <option key={x.VarityID}
                                                data-id={x.VarityID}
                                                value={x.VarityID}>
                                                    {x.Varity}
                                                </option>
                                            )
                                        }
                                    })}
                                </select>
                            </div>
                            <div className="form-group">
                                <span>ເກດເມັດ</span>
                                <select name="GradeID" onChange={(e) => handleSelectGrade(e)}
                                    className={`input form-control ${errors.GradeID && 'is-invalid'}`}>
    
                                     { GradeList && GradeList.map((x, y) => {
                                        if (x.Grade == values.Grade) {
                                            return (
                                                <option 
                                                key={x.GradeID}
                                                data-id={x.GradeID}
                                                value={x.GradeID} selected>
                                                    {x.Grade}
                                                </option>
                                            )
                                        } else {
                                            return (
                                                <option key={x.GradeID}
                                                data-id={x.GradeID}
                                                value={x.GradeID}>
                                                    {x.Grade}
                                                </option>
                                            )
                                        }
                                    })}
                                </select>
                            </div>
                            <div className="form-group">
                                <span>ສະຖານະເມັດ</span>
                                <select name="BeanStatusID" onChange={(e) => handleSelectBeanStatus(e)}
                                    className={`input form-control ${errors.BeanStatusID && 'is-invalid'}`}>
                                    { BeanStatusList && BeanStatusList.map((x, y) => {
                                        if (x.BeanStatus == values.BeanStatus) {
                                            return (
                                                <option 
                                                key={x.BeanStatusID}
                                                data-id={x.BeanStatusID}
                                                value={x.BeanStatusID} selected>
                                                    {x.BeanStatus}
                                                </option>
                                            )
                                        } else {
                                            return (
                                                <option key={x.BeanStatusID}
                                                data-id={x.BeanStatusID}
                                                value={x.BeanStatusID}>
                                                    {x.BeanStatus}
                                                </option>
                                            )
                                        }
                                    })}
                                </select>
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group">
                                <label>Proccess: </label>
                                <select name="ProccessID" onChange={(e) => handleSelectProccess(e)}
                                    className={`input form-control ${errors.ProccessID && 'is-invalid'}`}>
                                     { ProccessList && ProccessList.map((x, y) => {
                                        if (x.BeanStatus == values.BeanStatus) {
                                            return (
                                                <option 
                                                key={x.ProccessID}
                                                data-id={x.ProccessID}
                                                value={x.ProccessID} selected>
                                                    {x.Proccess}
                                                </option>
                                            )
                                        } else {
                                            return (
                                                <option key={x.ProccessID}
                                                data-id={x.ProccessID}
                                                value={x.ProccessID}>
                                                    {x.Proccess}
                                                </option>
                                            )
                                        }
                                    })}
                                </select>
                            </div>
                            <div className="form-group">
                                <span>ປະເພດຂົ້ວ</span>
                                <select name="RoasterID" onChange={(e) => handleSelectRoaster(e)}
                                    className={`input form-control ${errors.RoasterID && 'is-invalid'}`}>
              
                                    { RoasterTypeList && RoasterTypeList.map((x, y) => {
                                        if (x.Roaster == values.Roaster) {
                                            return (
                                                <option 
                                                key={x.RoasterID}
                                                data-id={x.RoasterID}
                                                value={x.RoasterID} selected>
                                                    {x.Roaster}
                                                </option>
                                            )
                                        } else {
                                            return (
                                                <option key={x.RoasterID}
                                                data-id={x.RoasterID}
                                                value={x.RoasterID}>
                                                    {x.Roaster}
                                                </option>
                                            )
                                        }
                                    })}
                                </select>
                            </div>
                            <div className="form-group">
                                <span>TestNote</span>
                                <input className={`input form-control ${errors.TestNote && 'is-invalid'}`} type="text" name="TestNote" onChange={(e) => handleInputChange(e)} value={values.TestNote || ''} required />
                                {errors.TestNote && (
                                    <p className="invalid-feedback">{errors.TestNote}</p>
                                )}
                            </div>
                        </div>
                        <div className="popUpfooter">
                            <button type="submit" className="btn btn-primary">
                                ບັນທຶກ
                            </button>
                            <button type="button" onClick={(e) => props.onClick(false)} className="btn btn-danger" data-dismiss="modal" aria-label="Close">
                                ກັບຄືນ
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default UpdateCoffee;
